export default "__VITE_ASSET__Bjg2Uvd___"